import React, { useEffect, useState } from 'react';
import { useField } from '@formiz/core';
import { FormGroup } from '../FormGroup';
import { Typeahead } from 'react-bootstrap-typeahead';

export const FieldSelect = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isSubmitted,
    resetKey,
    setValue,
    value,
    otherProps,
  } = useField(props);
  const { required, name } = props;
  const {
    children, label, options = [], placeholder, helper, ...rest
  } = otherProps;
  const [isTouched, setIsTouched] = useState(false);
  
  const showError = !isValid && (isTouched || isSubmitted);

  const handleChange = v => {
    if (v.length > 0){
      setValue(v[0].value)
    }
    else{
      setValue("");
    }
};

  useEffect(() => {
    setIsTouched(false);
  }, [resetKey]);

  const formGroupProps = {
    errorMessage,
    helper,
    id,
    isRequired: !!required,
    label,
    showError,
    name,
    ...rest,
  };

  return (
    <FormGroup {...formGroupProps} className="">
    <Typeahead
      id={id}
      className={`${showError ? 'is-error ' : ''}`}
      onBlur={() => setIsTouched(true)}
      aria-invalid={showError}
      aria-describedby={!isValid ? `${id}-error` : undefined}
      onChange={handleChange}
      //onChange={setValue}
      options={options}
      placeholder={placeholder}
      selected={options.filter(x => x.value === value)}
    />
    {showError && (
      <div id={`${id}-error`} className="error-feedback">
        { errorMessage }
      </div>
    )}
    {children}
    </FormGroup>
  );
};